<nb-layout>

  <nb-layout-column>
    <router-outlet></router-outlet>
  </nb-layout-column>

</nb-layout>
